export class ArrayHelper
{
    public static flattenTree<TItem, TKey>(
        array: TItem[],
        keySelector: (node: TItem) => TKey,
        childrenSelector: (node: TItem) => TItem[],
        parentId?: TKey
    )
        : (TItem & { parentId?: TKey })[]
    {
        const result: (TItem & { parentId?: TKey })[] = [];

        for (const node of array)
        {
            const nodeAndParentId: TItem & { parentId?: TKey } = {
                ...node,
                parentId: parentId,
            };

            result.push(nodeAndParentId);

            const children = childrenSelector(node);

            const descendants = ArrayHelper.flattenTree(
                children,
                keySelector,
                childrenSelector,
                keySelector(node),
            );
            result.push(...descendants);
        }

        return result;
    }
}
